import React, { useState, useEffect } from "react";

import { Route, BrowserRouter } from "react-router-dom";

import "./css/estilos.css";
import "./css/main.css";
import "./css/style.css";
import "./css/app.css";
import "./css/select.css";
import "./css/bootstrap/bootstrap.css";
import "./css/menu.css";
import "./css/fontawesome/css/all.css";
import "./css/linea-tiempo.css";

import logodnp from "./img/cce-color.png";
import logoFooter from "./img/LogoGovCo.png";

import youTubeFooter from "./img/youtubeFooter.png";
import twitterFooter from "./img/twitterFooter.png";
import facebookFooter from "./img/facebookFooter.png";
import linkedinFooter from "./img/linkedinFooter.png";
import RSSFooter from "./img/RSSFooter.png";
import Autenticar from "./pages/usuario/Autenticar.js";

import axios from "axios";
import * as misConstantes from "./js/constantes.js";

import Cotizaciones from "./pages/vistas/cotizaciones/Cotizaciones.js";
import Cotizacion from "./pages/vistas/cotizaciones/cotizacion/Cotizacion.js";
import CotizacionTercero from "./pages/vistas/cotizaciones/cotizacion/cotizacion/CotizacionTercero.js";

import SimulacionProveedors from "./pages/vistas/cotizaciones/cotizacion/simulacionProveedor/SimulacionProveedor.js";
import ItemMenuCerrarSesion from "./pages/template/menu/ItemMenuCerrarSesion.js";
import ErrorAutenticacion from "./pages/usuario/ErrorAutenticacion.js";
import AutenticarAdministrador from "./pages/usuario/AutenticarAdministrador.js";
import CambiarProveedor from "./pages/template/menu/CambiarProveedor.js";

import ModificacionesOrdenesCompra from "./pages/vistas/modificacionesOrdenesCompra/ModificacionesOrdenesCompra.js";
import ModificacionOrdenCompra from "./pages/vistas/modificacionesOrdenesCompra/modificacionOrdenCompra/ModificacionOrdenCompra.js";
import Simuladores from "./pages/vistas/simuladores/Simuladores.js";

import PreciosCatalogo from "./pages/vistas/simuladores/preciosCatalogo/PreciosCatalogo.js";
import CotizacionProveedor from "./pages/vistas/cotizaciones/cotizacion/cotizacionProveedor/CotizacionProveedor.js";

import { useInactivityLogout } from "./js/InactivityLogout.js";
import { configurarInterceptorAuth } from "./js/auth.js";
import InactivitySnackbar from "./js/InactivitySnackbar.js";
import VistaMantenimiento from "./pages/template/VistaMantenimiento.js";

import VersionApp from "./pages/template/VersionApp";
function App() {
  var codigoUsuario = localStorage.getItem(
    "simuladores.proveedores.codigoUsuario"
  );

  const [timeoutValue, setTimeoutValue] = useState(null);

  useEffect(() => {
    axios
      .post(misConstantes.URL_CONSULTA + "/ServletConfiguracionSesion")
      .then((response) => {
        const minutos = parseInt(response.data?.tiempoCierreSesion, 10);
        const newTimeout =
          !isNaN(minutos) && minutos > 0 ? minutos * 60 * 1000 : 30 * 60 * 1000;
        setTimeoutValue(newTimeout);
      })
      .catch(() => {
        setTimeoutValue(30 * 60 * 1000);
      });
  }, []);

  useInactivityLogout(() => {
    const codigoUsuario = localStorage.getItem(
      "simuladores.proveedores.codigoUsuario"
    );

    if (codigoUsuario != null) {
      sessionStorage.setItem("motivoLogout", "inactividad");
      localStorage.clear();
      window.location.href = "/";
    }
  }, timeoutValue || 10 * 60 * 1000);

  const [maintenanceMode, setMaintenanceMode] = useState(false);
  useEffect(() => {
    configurarInterceptorAuth();

    global.onMaintenanceDetected = () => {
      setMaintenanceMode(true);
    };
  }, []);

  if (maintenanceMode) {
    return <VistaMantenimiento />;
  }

  configurarInterceptorAuth();

  if (codigoUsuario == null) {
    var url = window.location.href;
    var data = url.split("/");
    var accion = data[data.length - 3];

    if (accion === "codigo") {
      var codigo = data[data.length - 2];
      var token = data[data.length - 1];
      var info = { codigo: codigo };

      axios
        .post(
          misConstantes.URL_CONSULTA + "/ServletCodigoAutenticacion",
          info,
          { params: info }
        )
        .then(function (response) {
          var respuesta = response.data;
          if (respuesta.respuesta === "exito") {
            if (respuesta.respuesta === "exito") {
              var codigoUsuario = JSON.parse(respuesta.objeto);
              localStorage.setItem(
                "simuladores.proveedores.codigoUsuario",
                codigoUsuario.codigo
              );
              localStorage.setItem("usuario", JSON.stringify(codigoUsuario));
              localStorage.setItem("token", token);
            }
            window.location.href = "/cotizaciones";
          } else {
            console.log(respuesta);
            window.location.href = "/codigo-equivocado";
          }
        })
        .catch(function (error) {});
      return <div>Cargando</div>;
    } else if (accion === "codigoProceso") {
      axios
        .post(misConstantes.URL_CONSULTA + "/ServletCodigoProceso", info, {
          params: info,
        })
        .then(
          function (response) {
            var respuesta = response.data;
            var objeto = JSON.parse(respuesta.objeto);

            if (respuesta.respuesta === "exito") {
              var mensaje = respuesta.mensaje;
              if (respuesta.respuesta === "exito") {
                var codigoUsuario = objeto.usuario;
                localStorage.clear();
                localStorage.setItem(
                  "simuladores.proveedores.codigoUsuario",
                  codigoUsuario.codigo
                );
                localStorage.setItem("usuario", JSON.stringify(codigoUsuario));

                window.location.href = objeto.url;
              }
            } else {
              this.setState({ mensaje: mensaje });
            }
          }.bind(this)
        )
        .catch(function (error) {});

      return <div>Cargando</div>;
    } else {
      accion = data[data.length - 1];
      if (accion === "codigo-equivocado") {
        return <ErrorAutenticacion></ErrorAutenticacion>;
      } else if (accion === "autenticacion-administrador") {
        return <AutenticarAdministrador></AutenticarAdministrador>;
      } else {
        return (
          <>
            <InactivitySnackbar />
            <Autenticar />
          </>
        );
      }
    }
  } else {
    if (accion === "codigoProceso") {
      axios
        .post(misConstantes.URL_CONSULTA + "/ServletCodigoProceso", info, {
          params: info,
        })
        .then(function (response) {
          var respuesta = response.data;
          var objeto = JSON.parse(respuesta.objeto);

          if (respuesta.respuesta === "exito") {
            if (respuesta.respuesta === "exito") {
              window.location.href = objeto.url;
            }
          } else {
            window.location.href = "/cotizaciones";
          }
        })
        .catch(function (error) {});
    }

    var usuario = JSON.parse(localStorage.getItem("usuario"));
    var mostrarCambio = "none";
    if (usuario.usuario.tipoUsuarioProveedor === 2) {
      mostrarCambio = "initial";
    }

    return (
      <BrowserRouter>
        <div>
          <div
            class="content"
            style={{ display: "fixed", width: "100%", top: "0px" }}
            id="cabezoteAzulLogosBlanco"
          >
            <div class="fondo-azul-sin-texto"></div>
            <div class="fondo-azul" style={{ marginBottom: "20px" }}>
              <div class="container">
                <nav
                  class="navbar navbar-expand-lg navbar-light"
                  style={{ paddingLeft: "0px" }}
                >
                  <div class="logoGov">
                    <a href="https://www.gov.co/" target="_blank">
                      <img
                        alt="Logo colombia compra"
                        style={{ maxWidth: "150px" }}
                        class="img-fluid logovco"
                        src="https://1a1.click/img/Logo%20govco.png"
                      />
                    </a>
                  </div>
                  <ul class="navbar-nav ml-auto">
                    <li
                      class="nav-item active"
                      style={{ paddingTop: "2px" }}
                    ></li>
                  </ul>
                </nav>
              </div>
              <div class="container">
                <div class="fila">
                  <div
                    class="col-6 col-md-3 mr-auto"
                    style={{ paddingLeft: "10px !important" }}
                  >
                    
                  </div>
                  <div
                    class="col-6 col-md-3 ml-auto"
                    style={{ paddingLeft: "10px !important" }}
                  >
                    <a href="https://www.colombiacompra.gov.co/">
                      <img id="logodnp" src={logodnp} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="menu container">
            <nav class="navbar navbar-expand-lg navbar-light">
              <button
                class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarCollapse"
                aria-controls="navbarCollapse"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="navbar-toggler-icon"></span>
              </button>
              <div
                class="collapse navbar-collapse menuCompleto"
                id="navbarCollapse"
              >
                <ul class="navbar-nav ml-auto">
                  <li class="nav-item" style={{ width: "20%" }}>
                    <a class="nav-link primerNivel" href="/cotizaciones">
                      Cotizaciones
                    </a>
                  </li>
                  <li class="nav-item" style={{ width: "30%" }}>
                    <a class="nav-link primerNivel" href="/simuladores">
                      Simuladores
                    </a>
                  </li>
                  <li class="nav-item" style={{ width: "30%" }}>
                    <a
                      class="nav-link primerNivel"
                      href="/modificaciones-ordenes-compra"
                    >
                      Modificaciones ordenes de compra
                    </a>
                  </li>

                  <li class="nav-item" style={{ width: "20%" }}>
                    <a
                      class="nav-link primerNivel"
                      href="index.jsp?accion=usuario"
                      id="dropdown_usuario"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Usuario
                    </a>
                    <ul
                      class="dropdown-menu submenu-primero"
                      aria-labelledby="dropdown_usuario"
                      style={{ maxWidth: "200px", left: "auto !important" }}
                    >
                      <li style={{ display: mostrarCambio }}>
                        <CambiarProveedor></CambiarProveedor>
                      </li>
                      <li>
                        <ItemMenuCerrarSesion></ItemMenuCerrarSesion>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </nav>
          </div>

          {/*
           * ----------------------------------------------------------------
           * Cotizaciones
           * ----------------------------------------------------------------
           *
           */}

          <Route exact path="/">
            <Cotizaciones></Cotizaciones>
          </Route>
          <Route path="/cotizaciones">
            <Cotizaciones></Cotizaciones>
          </Route>
          <Route path="/cotizacion/:id">
            <Cotizacion></Cotizacion>
          </Route>
          <Route path="/modificaciones-ordenes-compra">
            <ModificacionesOrdenesCompra></ModificacionesOrdenesCompra>
          </Route>
          <Route path="/modificacion-orden-compra/:id">
            <ModificacionOrdenCompra></ModificacionOrdenCompra>
          </Route>
          <Route path="/simuladores">
            <Simuladores></Simuladores>
          </Route>
          <Route path="/precios-catalogo">
            <PreciosCatalogo></PreciosCatalogo>
          </Route>
          <Route path="/simulacion-proveedor/:idSimulacion/:idSimulacionProveedor">
            <SimulacionProveedors></SimulacionProveedors>
          </Route>
          <Route path="/cotizacion-proveedor/:idSimulacion/:idProveedor/:nombreProveedor">
            <CotizacionProveedor></CotizacionProveedor>
          </Route>
          <Route path="/cotizacion-tercero/:idSimulacion/:codigoCotizacion">
            <CotizacionTercero></CotizacionTercero>
          </Route>

          <div style={{ backgroundColor: "#0164c1" }}>
            <div class="container foot pt-4">
              <div class="fila">
                <div class="col-12 col-md-2 bd">
                  <img class="img-fluid" src={logoFooter} />
                </div>

                <div class="col-12 col-md-6 py-4 bd">
                  <h5 class="blanco ">Colombia Compra Eficiente</h5>

                  <p class="blanco small">
                    Carrera 7 No 26 - 20 Piso 23 / Dirección General / Edificio
                    Seguros Tequendama (Bogotá D.C)
                    <br />
                    Código Postal: 110311
                    <br />
                    Horario de atención: de 8:30 a.m a 430 p.m / Lunes a Viernes
                  </p>

                  <p>
                    <a class="blanco" href="/sitemap">
                      Mapa del sitio
                    </a>
                  </p>
                  <div class="fila">
                    <div class="col-md-1 col-2">
                      <a
                        href="https://www.facebook.com/ColombiaCompraEficiente/"
                        target="_blank"
                      >
                        <img alt="facebook" src={facebookFooter} />
                      </a>
                    </div>
                    <div class="col-md-1 col-2">
                      <a
                        href="https://twitter.com/colombiacompra"
                        target="_blank"
                      >
                        <img alt="twitter" src={twitterFooter} />
                      </a>
                    </div>
                    <div class="col-md-1 col-2">
                      <a
                        href="https://www.linkedin.com/company/colombia-compra-eficiente/"
                        target="_blank"
                      >
                        <img alt="linkedin" src={linkedinFooter} />
                      </a>
                    </div>
                    <div class="col-md-1 col-2">
                      <a
                        href="https://www.youtube.com/channel/UC2pHOdAhZovC5vE7IsuiGbg"
                        target="_blank"
                      >
                        <img alt="youtube" src={youTubeFooter} />
                      </a>
                    </div>
                    <div class="col-md-1 col-2">
                      <a href="/node/22/" target="_blank">
                        <img alt="rss" src={RSSFooter} />
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-4 py-4">
                  <h6 class="blanco">Contacto de notificaciones judiciales</h6>
                  <p class="blanco small" style={{ color: "white" }}>
                    <a
                      target="_blank"
                      class="blanco"
                      href="mailto:notificacionesjudiciales@colombiacompra.gov.co"
                    >
                      notificacionesjudiciales@colombiacompra.gov.co
                    </a>
                    <br />
                    Nit. 900514913-2
                    <br /> Linea nacional gratuita: 018000520808
                    <br />
                    PBX: (+57) (1) 7956600
                    <br /> Línea en Bogotá: (+57) (1) 7456788
                  </p>
                </div>
              </div>
              <div class="col-12">
                <hr />
                <div class="d-flex flex-wrap justify-content-between">
                  <p class="text-left blanco">
                    &copy; {new Date().getFullYear()}. Colombia Compra Eficiente Todos los derechos
                    reservados
                  </p>
                  <VersionApp />
                </div>
              </div>
            </div>
          </div>
        </div>
      </BrowserRouter>
    );
  }
}
export default App;
